import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { SftpImportConfigurationWorkflow, getSftpImportFrequencyDescriptions, FrequencyEnum } from '../../../store/Models/Api/SftpImportModels';

interface ScheduleInfoSectionLocalProps {
    configData: SftpImportConfigurationWorkflow;
}

type ScheduleInfoSectionProps = ScheduleInfoSectionLocalProps & ToxnotComponentProperties;

class ScheduleInfoSectionComponent extends ToxnotComponent<ScheduleInfoSectionProps> {
    public render() {
        const { configData, appServices } = this.props;
        const frequencyDescriptions = getSftpImportFrequencyDescriptions(appServices);

        return (
            <>
                <p><strong>{this.localizeString("Frequency")}:</strong> {frequencyDescriptions[configData.frequency as FrequencyEnum] || configData.frequency}</p>
                <p><strong>{this.localizeString("Start Time")}:</strong> {configData.startTime}</p>
                <p><strong>{this.localizeString("Time Zone")}:</strong> {configData.timeZone}</p>
            </>
        );
    }
}

export const ScheduleInfoSection = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ScheduleInfoSectionComponent);
